declare namespace $ {

	type $mol_string__value_exso_sheets_login_1 = $mol_type_enforce<
		ReturnType< $exso_sheets_login['name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_exso_sheets_login_2 = $mol_type_enforce<
		ReturnType< $exso_sheets_login['name_label'] >
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__bid_exso_sheets_login_3 = $mol_type_enforce<
		ReturnType< $exso_sheets_login['name_bid'] >
		,
		ReturnType< $mol_form_field['bid'] >
	>
	type $mol_form_field__control_exso_sheets_login_4 = $mol_type_enforce<
		ReturnType< $exso_sheets_login['Name_control'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_password__value_exso_sheets_login_5 = $mol_type_enforce<
		ReturnType< $exso_sheets_login['pass'] >
		,
		ReturnType< $mol_password['value'] >
	>
	type $mol_form_field__name_exso_sheets_login_6 = $mol_type_enforce<
		ReturnType< $exso_sheets_login['pass_label'] >
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__bid_exso_sheets_login_7 = $mol_type_enforce<
		ReturnType< $exso_sheets_login['pass_bid'] >
		,
		ReturnType< $mol_form_field['bid'] >
	>
	type $mol_form_field__control_exso_sheets_login_8 = $mol_type_enforce<
		ReturnType< $exso_sheets_login['Pass_control'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_button_major__title_exso_sheets_login_9 = $mol_type_enforce<
		ReturnType< $exso_sheets_login['submit_label'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__event_click_exso_sheets_login_10 = $mol_type_enforce<
		ReturnType< $exso_sheets_login['event_submit'] >
		,
		ReturnType< $mol_button_major['event_click'] >
	>
	type $mol_form__form_fields_exso_sheets_login_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['form_fields'] >
	>
	type $mol_form__buttons_exso_sheets_login_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['buttons'] >
	>
	export class $exso_sheets_login extends $mol_page {
		name_label( ): string
		name_bid( ): string
		name( next?: string ): string
		Name_control( ): $mol_string
		Name_field( ): $mol_form_field
		pass_label( ): string
		pass_bid( ): string
		pass( next?: string ): string
		Pass_control( ): $mol_password
		pass_field( ): $mol_form_field
		submit_label( ): string
		event_submit( ): any
		Submit( ): $mol_button_major
		Form( ): $mol_form
		title( ): string
		head( ): readonly(any)[]
		dirty( next?: boolean ): boolean
		required( ): string
		errors( ): ({ 
			'invalid_credentials': string,
		}) 
		login( next?: any ): any
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=login.view.tree.d.ts.map